import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import useContentfulPromotionContent from 'hooks/useContentfulPromotionContent';
import BannerTextSection from 'components/consumer/image-with-text-banner2/BannerTextSection';

const ShopPagePromotionPanel = () => {
  const { promotionData } = useContentfulPromotionContent();
  const [textContent, updateTextContent] = useState(null);
  const [colors, updateColors] = useState(null);
  const [ctaColors, updateCtaColors] = useState(null);
  const toggleInputType = {};

  useEffect(() => {
    if (!promotionData) return;
    const {
      title,
      body,
      disclaimer,
      icon,
      backgroundImage,
      heroTextBackgroundColor,
      heroFancyText,
      heroFancyTextColor,
      heroLogomark,
      mainTextColor,
      ctaTextColor,
      ctaBackgroundColor,
    } = promotionData;
    updateTextContent({
      icon,
      heroFancyText,
      heroFancyTextColor,
      heroLogomark,
      body,
      title,
      disclaimer,
      backgroundImage,
    });

    updateColors({
      textHex: mainTextColor,
      backgroundHex: backgroundImage ? 'transparent' : heroTextBackgroundColor,
    });
    updateCtaColors({
      textHex: ctaTextColor,
      backgroundHex: ctaBackgroundColor,
    });
  }, [promotionData]);

  if (!textContent) return null;
  return (
    <div className="[grid-area:ShopPagePromotionPanel] object-cover max-[767px]:items-center max-[767px]:flex max-[767px]:flex-col max-[767px]:pt-6 max-[767px]:px-6 max-[767px]:pb-8 max-[767px]:text-center">
      <BannerTextSection
        config={{ textContent, colors, ctaColors, toggleInputType }}
        isHomepage={false}
        variant="ShopPagePromotionPanel"
      />
    </div>
  );
};

ShopPagePromotionPanel.propTypes = {
  config: PropTypes.shape({
    textContent: PropTypes.shape({
      title: PropTypes.string,
      subTitle: PropTypes.string,
      disclaimer: PropTypes.string,
    }),
    colors: PropTypes.shape({
      backgroundHex: PropTypes.string,
      textHex: PropTypes.string,
    }),
    image: PropTypes.shape({
      path: PropTypes.string,
    }),
    background: PropTypes.shape({
      imagePath: PropTypes.string,
    }),
  }),
};

export default ShopPagePromotionPanel;
